import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';
import { ConsultarCampaniasActiva } from '../../../services/WebAPI_Utrahuilca';
import ConsultaOverlay from "./Consulta";
import TiendaPremios from "./TiendaPremios";

class Seccion01CooperaGanaMas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showTyCModal: false,
            screenSize: this.getScreenSize(),
            activeButton: null,
            errors: {},
            overlay: false,
            tipoIden: 'DEFAULT',
            ptosAsignados: 'DEFAULT',
            nit: '',
            fecExpe: '',
            stateLoading: false,
            fecSorteo: '',
            infoPtosAsignados: [],
            nombreAso: '',
            valor: 'none',
            valorCheckCamp: 'none',
            estadoSolicitud: true,
            activeBtnConsulta: null,
            puntos: 0,
            correo: '',
            celular: '',
            id_cliente: 0
        };

        this.recaptchaRef = React.createRef();
        this.resultadoRef = React.createRef();
    }

    fetchCampActiva = () => {
        const data = {
            tran: 8,
            id_camp: 5
        }

        return ConsultarCampaniasActiva(data)
            .then(response => {
                if (response.data && response.data.length > 0) {
                    if (response.data[0].codresp) {
                        this.setState({ valorCheckCamp: 'none' });
                    }
                    else {
                        this.setState({ valorCheckCamp: 'block' });
                    }
                }
                else {
                    this.setState({ valorCheckCamp: 'none' });
                }
            })
            .catch(error => {
                this.setState({ valorCheckCamp: 'none' });
            });
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    getScreenSize = () => {
        const width = window.innerWidth;

        if (width <= 480) return 'xs';
        if (width <= 768) return 'sm';
        if (width <= 1025) return 'md';
        if (width > 1025 && width <= 1200) return 'xmd';
        if (width <= 1440) return 'lg';
        if (width <= 1600) return 'xl';
        return 'xxl';
    };

    handleResize = () => {
        const screenSize = this.getScreenSize();
        if (screenSize !== this.state.screenSize) {
            this.setState({ screenSize });
        }
    };

    handleButtonClick = (id) => {
        switch (id) {
            case 0: //MODAL DE CONSULTA
                if (this.props.mostrarOnClick) {
                    this.props.mostrarOnClick(true);
                }
                break;

            case 1: //BOTON COMO PARTICIPAR
                if (this.props.onButtonClick) {
                    this.props.onButtonClick(2);
                }
                break;

            case 2: //BOTON PREMIOS
                if (this.props.onButtonClick) {
                    this.props.onButtonClick(4);
                }
                break;

            case 3: //BOTON TyC
                this.setState({ showTyCModal: true });
                break;

            default:
                break;
        }
    };

    getButtonContainerStyle = (screenSize) => {
        const baseStyle = {
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column',
            zIndex: 1
        };

        const screenStyles = {
            xs: {
                top: '51%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            sm: {
                top: '51.5%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            md: {
                top: '50.1%',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: '1px',
                alignItems: 'center'
            },
            xmd: {
                top: '39%',
                right: '9%',
                gap: '1px',
                alignItems: 'flex-end',
            },
            lg: {
                top: '39%',
                right: '6%',
                gap: '1px',
                alignItems: 'flex-end',
            },
            xl: {
                top: '27%',
                right: '8%',
                gap: '1px',
                alignItems: 'flex-end'
            },
            xxl: {
                top: '27%',
                right: '8%',
                gap: '1px',
                alignItems: 'flex-end'
            }
        };

        return { ...baseStyle, ...screenStyles[screenSize] };
    };

    getButtonStyle = (screenSize, imageUrl, isActive) => {
        const sizeStyles = {
            xs: { width: '65vw', height: '12vw' },
            sm: { width: '77.35vw', height: '12vw' },
            md: { width: '58vw', height: '10vw' },
            xmd: { width: '40vw', height: '6vw' },
            lg: { width: '48vmin', height: '7.2vmin' },
            xl: { width: '53vmin', height: '9vmin' },
            xxl: { width: '60vmin', height: '11vmin' }
        }

        const scaleUp = screenSize === 'xs' ? 1.19 : 1;
        const scaleActive = isActive ? 0.96 : 1;

        return {
            ...sizeStyles[screenSize],
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'auto',
            backgroundRepeat: 'no-repeat',
            display: 'block',
            margin: 'auto',
            transform: `scale(${scaleUp * scaleActive})`,
            transition: 'transform 0.15s ease',
            cursor: 'pointer'
        };
    };

    textInput = (e) => {
        const { name, value } = e.target;

        if (name === "fecExpe") {
            //SE TOMA EXACTAMENTE EL AÑO
            const yearPart = value.split("-")[0];

            if (yearPart.length > 4) {
                this.setState({ [yearPart]: "" }); return;
            }
        }

        this.setState({ [name]: value });
    };

    getActiveButton = (isActive) => {
        return {
            outline: 'none',
            display: 'block',
            margin: 'auto',
            transition: 'transform 0.15s ease',
            transform: isActive ? 'scale(0.96)' : 'scale(1)',
            backgroundColor: 'transparent',
            border: 0
        };
    }

    resetModalForm = () => {
        this.setState({
            tipoIden: 'DEFAULT',
            nit: '',
            fecExpe: '',
            errors: {},
            activeBtnConsulta: null,
            puntos: 'DEFAULT',
            valor: 'none'
        });

        if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
        }
    };

    validRecat = () => {
        if (this.recaptchaRef.current.getValue()) {
            this.setState({
                estadoSolicitud: false
            })
        } else {
            this.setState({
                estadoSolicitud: true
            })
        }
    }

    // Limpia, no se recrea en cada render
    cerrarOverlay = (mostrar) => {
        this.props.mostrarOnClick(false);
        this.recibirInfoConsulta(0,0,'','','','');
    };

    recibirInfoConsulta= (idcliente, puntos, nombre, numnit, correo, telcel, tipoiden) => {
        this.setState({
            id_cliente: idcliente,
            puntos: puntos,
            nombreAso: nombre,
            nit: numnit,
            correo: correo,
            celular: telcel,
            tipoIden: tipoiden
        });
    };

    render() {
        const { screenSize, activeButton } = this.state;
        const { showOverlay } = this.props;
        const buttonImages = [`${URLImgFront}/assets/EstrategiasComerciales/BotonConsultaPuntos.svg`, `${URLImgFront}/assets/EstrategiasComerciales/BotonComoParticipar.svg`, `${URLImgFront}/assets/EstrategiasComerciales/AlternativasRedencion.svg`, `${URLImgFront}/assets/EstrategiasComerciales/BotonTyC.svg`];
        return (
            <React.Fragment>
                <div id="seccion01" data-aos="fade-up" data-aos-delay="3240">
                    <div style={{ position: 'relative', width: '100%' }}>
                        <picture>
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/CooperaGanaMasMovil.jpg`} media="(max-width: 768px)" />
                            <source srcSet={`${URLImgFront}/assets/EstrategiasComerciales/CooperaGanaMasMovil.jpg`} media="(max-width: 1025px )" />
                            <img className="img-fluid" style={{ width: '100%', height: 'auto', display: 'block', touchAction: 'manipulation' }} src={`${URLImgFront}/assets/EstrategiasComerciales/CooperaGanaMas.jpg`} alt="Estrategia Comercial Coopera y Gana Más" />
                        </picture>

                        {!showOverlay ? (
                            <div className="aos-button-wrapper" data-aos="zoom-in-down" data-aos-delay="3240" >
                                <div style={this.getButtonContainerStyle(screenSize)}>
                                    <div className="mb-3 w-100">
                                        <img className="img-fluid w-100" src={`${URLImgFront}/assets/EstrategiasComerciales/GloboBlanco.svg`} alt="-" />
                                    </div>
                                    {buttonImages.map((imageUrl, i) => (
                                        <div
                                            key={i}
                                            id={`button-${i}`}
                                            data-id={i}
                                            className="button-img"
                                            style={this.getButtonStyle(screenSize, imageUrl, activeButton === i)}
                                            onClick={() => this.handleButtonClick(i)}
                                            onTouchStart={() => this.setState({ activeButton: i })}
                                            onTouchEnd={() => this.setState({ activeButton: null })}
                                            onMouseDown={() => this.setState({ activeButton: i })}
                                            onMouseUp={() => this.setState({ activeButton: null })}
                                            onMouseLeave={() => this.setState({ activeButton: null })}
                                        ></div>
                                    ))}
                                </div>
                            </div>
                        ) : (<ConsultaOverlay cerrarOverlay={this.cerrarOverlay} onInfoConsulta={this.recibirInfoConsulta} />)}
                    </div>
                    {showOverlay ? (<TiendaPremios idcliente={this.state.id_cliente} puntos={this.state.puntos} nombre={this.state.nombreAso} correo={this.state.correo} celular={this.state.celular} nit={this.state.nit} tipoiden={this.state.tipoIden} cerrarOverlay={this.cerrarOverlay} />) : (null)}
                </div>

                {this.state.showTyCModal && (
                    <div className="tyc-overlay" data-aos="zoom-in" onClick={() => this.setState({ showTyCModal: false })}>
                        <div className="tyc-modal" onClick={(e) => e.stopPropagation()}>
                            <h5 className="text-center">Términos y Condiciones</h5>
                            <iframe src={`${URLImgFront}/assets/Archivos/TermYCondiciones_CooperaGanaMasUTRAHUILCA2026.pdf#toolbar=0`} width="100%" height="95%" style={{ border: 'none', borderRadius: '10px' }} title="Términos y Condiciones" ></iframe>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Seccion01CooperaGanaMas;